export { default } from "./VerifyOTP";